import { ApiClientWrapper } from '@spike/api-client';
import { useApiClientWrapper } from 'hooks';
import { useMemo } from 'react';

/**
 * Wrapper whose `marketplaceId` is the selected inbox location. Threads and inboxes are per
 * location (design doc D10) and every `@spike/omnichannel-action` thunk scopes by
 * `apiClientWrapper.marketplaceId`, so this is the only override needed for multi-location.
 */
export const useScopedApiClientWrapper = (marketplaceId: number): ApiClientWrapper => {
    const apiClientWrapper = useApiClientWrapper();

    return useMemo(
        () =>
            apiClientWrapper.marketplaceId === marketplaceId
                ? apiClientWrapper
                : { ...apiClientWrapper, marketplaceId },
        // the app wrapper is rebuilt every render; only the location matters here
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [marketplaceId]
    );
};

export default useScopedApiClientWrapper;
